<template>
  <div>
    <b-container fluid>
      <b-row align-h="between">
        <h1>通信経路</h1>
        <button
          class="btn btn-outline-secondary"
          @click="pageBack"
        >戻る</button>
      </b-row>
      <b-row align-h="start">
        <button
          class="btn btn-outline-info create_btn_cp"
          @click="displayNewCommnicationDesign"
        >新規作成</button>
      </b-row>
      <b-row align-h="center">
        <b-col sm="9">
          <newCommunicationPath
            :show="showNewCommnicationDesign"
            @updateList="refreshCommunicationPath"
          />
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col sm="9">
          <updateCommunicationPath
            :show="showUpdateCommnicationDesign"
            :detail="detailUpdateTarget"
            @updateList="refreshCommunicationPath"
          />
        </b-col>
      </b-row>
      <b-table
        :fields="fields"
        :items="communicationPath"
        :sort-by.sync="sortBy"
        :sort-asc.sync="sortAsc"
        tbody-tr-class="parent_row"
        bordered
      >
        <template v-slot:head()="data">
          <div >
            <template v-if="data.label === '宛先分割'">
              <div>
                <b-row align-h="center">{{ data.label }}</b-row>
                <b-row align-h="around">
                  <span>SA</span>
                  <span>SR</span>
                  <span>DA</span>
                  <span>DR</span>
                  <span>Protcol</span>
                </b-row>
              </div>
            </template>
            <template v-else>
              {{ data.label }}
            </template>
          </div>
        </template>
        <template v-slot:cell(communication_path_list)="data">
          <b-row align-h="around">
            <b-table
              :fields="childFields"
              :items="data.item.communication_path_list"
              table-class="child_margin"
              tbody-tr-class="child_row"
            >
            </b-table>
          </b-row>
        </template>
        <template v-slot:cell(delete_update)="data">
          <div>
            <b-button
              size="sm"
              variant="outline-secondary"
              class="mini_button"
              @click="displayUpdateCommnicationDesign(data)"
            >更新</b-button><br>
            <b-button
              size="sm"
              variant="outline-danger"
              class="mini_button"
              @click="displayDeleteCommnicationPath(data)">削除</b-button>
          </div>
        </template>
      </b-table>
      <b-modal
        v-model="showConfirmDelete"
        hide-footer
      >
        <b-row align-h="center">
          <p>削除しますか？</p>
        </b-row>
        <b-row align-h="around">
          <button
            class="btn btn-outline-danger"
            @click="deleteCommnicationPath"
          >はい</button>
          <button
            class="btn btn-outline-secondary"
            @click="showConfirmDelete = !showConfirmDelete"
          >いいえ</button>
        </b-row>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import newCommunicationPath from './newCommunicationPath.vue'
import updateCommunicationPath from './updateCommunicationPath.vue'
import { API, graphqlOperation } from 'aws-amplify'
export default {
  name: 'CommunicationPathes',
  components: {
    newCommunicationPath,
    updateCommunicationPath
  },
  data () {
    return {
      sortBy: 'no',
      sortAsc: true,
      communicationPath: [],
      fields: [
        { key: 'no', label: '番号', sortable: true, sortDirection: 'ASC' },
        { key: 'design_sender', label: '設計用送信元', sortable: true },
        { key: 'design_destination', label: '設計用送信先', sortable: true },
        { key: 'physical_connection', label: '物理接続', sortable: true },
        { key: 'communication_path_list', label: '宛先分割' },
        { key: 'delete_update', label: '更新削除' }
      ],
      childFields: [
        { key: 'sa', thStyle: { display: 'none' } },
        { key: 'sr', thStyle: { display: 'none' } },
        { key: 'da', thStyle: { display: 'none' } },
        { key: 'dr', thStyle: { display: 'none' } },
        { key: 'protocol', thStyle: { display: 'none' } }
      ],
      showConfirmDelete: false,
      deleteTarget: '',
      showNewCommnicationDesign: false,
      showUpdateCommnicationDesign: false,
      detailUpdateTarget: {},
      nowEdit: ''
    }
  },
  async created () {
    this.listCommunicationPath()
  },
  methods: {
    async listCommunicationPath () {
      const ComPath = await API.graphql(graphqlOperation(`
        query listCommunicationPath {
          listCommunicationPathMaster{
            items {
              no
              design_sender
              design_destination
              physical_connection
              communication_path_list {
                sa
                sr
                da
                dr
                protocol
              }
            }
          }
        }
      `))
      this.$log.debug('======= list communicationPath result ========', ComPath)
      this.communicationPath = [...ComPath.data.listCommunicationPathMaster.items]
      this.showNewCommnicationDesign = false
      this.showUpdateCommnicationDesign = false
    },
    async deleteCommnicationPath () {
      try {
        const mutationString = `
          mutation deleteCommunicationPathMaster {
            deleteCommunicationPathMaster (
              no: ${this.deleteTarget}
            ) {
              no
              design_sender
              design_destination
              physical_connection
              communication_path_list {
                sa
                sr
                da
                dr
                protocol
              }
            }
          }`
        this.$log.debug('======= delete communicationPath mutation ========', mutationString)
        const result = await API.graphql(graphqlOperation(mutationString))
        this.$log.debug('======= delete communicationPath result ========', result)
        this.listCommunicationPath()
        this.showConfirmDelete = false
        this.makeToast('成功', '削除に成功しました', 'info')
      } catch (e) {
        this.$log.debug('======= delete communicationPath error ========', e)
        this.makeToast('成功', '削除に失敗しました', 'danger')
      }
    },
    pageBack () {
      this.$router.go(-1)
    },
    displayDeleteCommnicationPath (data) {
      this.deleteTarget = data.item.no
      this.showConfirmDelete = true
    },
    displayUpdateCommnicationDesign (args) {
      this.showNewCommnicationDesign = false
      if (this.nowEdit === args.item.no) {
        this.showUpdateCommnicationDesign = !this.showUpdateCommnicationDesign
      } else {
        this.showUpdateCommnicationDesign = true
        this.nowEdit = args.item.no
      }
      this.detailUpdateTarget = args
    },
    displayNewCommnicationDesign () {
      this.showUpdateCommnicationDesign = false
      this.showNewCommnicationDesign = !this.showNewCommnicationDesign
    },
    refreshCommunicationPath () {
      this.listCommunicationPath()
      this.$router.go()
    }
  }
}
</script>
<style>
  .create_btn_cp{
    margin-right: 2rem;
  }
  .child_header{
    height: 0;
    padding: 0;
    margin: 0;
    border: none;
    word-wrap: break-word;
  }
  .child_margin{
    border: none;
    margin-bottom: 0 !important;
  }
  tr.parent_row>td {
    padding:0 15px;
  }
  tr.child_row>td {
    word-break : break-all;
  }
  .mini_button{
    margin: 0 -15px;
  }
</style>
